export default "__VITE_ASSET__C73yjEDF__"